/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import React, {PureComponent} from 'react';
import DvrdSelect from "./dvrdSelect";
import {ChangeFunction, ErrorType, SelectItemShape} from "../util/interfaces";
import {stringContains} from '../util/controlUtil';

interface Props {
    onChange: ChangeFunction;
    value: string | number;
    items: SelectItemShape[];
    disabled?: boolean;
    label?: string;
    error?: ErrorType;
    className?: string;
    labelClassName?: string;
    valueClassName?: string;
    arrowClassName?: string;
    errorClassName?: string;
    itemContainerClassName?: string;
    itemClassName?: string;
    itemsPosition: 'top' | 'bottom';
    selectOnly: boolean;
    optionsContainerHeight: number | string;
    unControlled?: boolean;
}

interface State {
    searchValue: string;
    value: string | number;
}

export default class DvrdSelectController extends PureComponent<Props, State> {
    private select: DvrdSelect;

    static defaultProps = {
        itemsPosition: 'bottom',
        selectOnly: true,
        optionsContainerHeight: '15rem',
    };

    state: State = {
        searchValue: '',
        value: this.props.value,
    };

    onChange = (value: string | number) => () => {
        this.props.onChange(value);
        this.setState({value});
    };

    onChangeSearch = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const {value} = evt.target;
        this.setState({searchValue: value});
    };

    onOpen = (evt: React.MouseEvent) => {
        if (this.select) this.select.onClickElement(evt);
    };

    getItems = () => {
        const items = this.props.items.slice(), {searchValue} = this.state;
        if (!searchValue) return items;
        return items.filter((item) => stringContains(item.label.toString(), searchValue))
    }

    render = () => {
        const {
            arrowClassName, label, error, className, labelClassName, valueClassName, itemContainerClassName,
            itemClassName, errorClassName, disabled, itemsPosition, selectOnly, optionsContainerHeight, unControlled
        } = this.props, {searchValue} = this.state;
        const value = !!unControlled ? this.state.value : this.props.value;
        return (
            <DvrdSelect onChange={this.onChange} value={value} items={this.getItems()} disabled={disabled}
                        errorClassName={errorClassName} itemClassName={itemClassName}
                        itemContainerClassName={itemContainerClassName} valueClassName={valueClassName}
                        labelClassName={labelClassName} className={className} error={error} label={label}
                        arrowClassName={arrowClassName} itemsPosition={itemsPosition} ref={(ref: DvrdSelect) => {
                this.select = ref
            }} searchValue={searchValue} onChangeSearch={this.onChangeSearch} selectOnly={selectOnly}
                        optionsContainerHeight={optionsContainerHeight}/>
        );
    }
};